import React, { useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import "../../../assets/topstudio/styles/Player.css";
import useSocket from "../../../hooks/useSocket";
import useClosedPhaseOverlay from "../../../hooks/useClosedPhaseOverlay";
import TeenPattisCasinoBetslipWeb from "./teenpatti_casino_betslip_web";
import TPPopUpBetSlip from "./teenpatti_casino_betslip_popup.jsx";
import axiosInstance from "../../../utils/axiosInstance";
import Volume from "./Volume";
import AAAResult from "../../client/tp-studio/tp-result/AAAResult.jsx";
import { isMobile } from "react-device-detect";
import AaaRules from "./pop-up/aaa-rules.jsx";


import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";

export default function AAAVirtual() {
  const dispatch = useDispatch();

  const [stakeLimit, setStakeLimit] = useState(0);
  const [showRules, setShowRules] = useState(false);
  const [showBetSlip, setShowBetSlip] = useState(false);
  const [placeBetObject, setPlaceBetObject] = useState({});
  const [betErrorMessageObj, setBetErrorMessage] = useState({});
  const [open, setOpen] = useState(false);
  const [roundId, setRoundId] = useState("");

  const [amarBook, setAmarBook] = useState(0);
  const [akbarBook, setAkbarBook] = useState(0);
  const [anthonyBook, setAnthonyBook] = useState(0);
  const [oddBook, setOddBook] = useState(0);
  const [evenBook, setEvenBook] = useState(0);
  const [blackBook, setBlackBook] = useState(0);
  const [redBook, setRedBook] = useState(0);
  const [under7Book, setUnder7Book] = useState(0);
  const [over7Book, setOver7Book] = useState(0);

  const [amarWin, setAmarWin] = useState(false);
  const [akbarWin, setAkbarWin] = useState(false);
  const [anthonyWin, setAnthonyWin] = useState(false);
  const [oddWin, setOddWin] = useState(false);
  const [evenWin, setEvenWin] = useState(false);
  const [blackWin, setBlackWin] = useState(false);
  const [redWin, setRedWin] = useState(false);
  const [under7Win, setUnder7Win] = useState(false);
  const [over7Win, setOver7Win] = useState(false);

  const [showBetSlipPopup, setShowBetSlipPopup] = useState(false);
  const [betButtonShow, setBetButtonShow] = useState(true);
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [resultList, setResultList] = useState([]);
  const [displayLoader, setDisplayLoader] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(1);

  const [b1Val, setB1Val] = useState(0);
  const [b2Val, setB2Val] = useState(0);
  const [b3Val, setB3Val] = useState(0);
  const [b4Val, setB4Val] = useState(0);
  const [b5Val, setB5Val] = useState(0);
  const [b6Val, setB6Val] = useState(0);
  const [b7Val, setB7Val] = useState(0);
  const [b8Val, setB8Val] = useState(0);
  const [b9Val, setB9Val] = useState(0);
  const [b10Val, setB10Val] = useState(0);
  const [pairAVal, setPairAVal] = useState(0);
  const [pairBVal, setPairBVal] = useState(0);
  const [lastStatus, setLastStatus] = useState(null);

  const [resultData, setResultData] = useState([]);
  /* ================= TIMER ================= */
  const TOTAL_SECONDS = 30;
  const [timeLeft, setTimeLeft] = useState(TOTAL_SECONDS);
  const localTimerRef = useRef(null);

  /* ================= SINGLE CARD STATE ================= */
  const [shownCard, setShownCard] = useState("1");
  const [shouldFlip, setShouldFlip] = useState(false);
  const lastEvtStatusRef = useRef(null);

  /* ================= SOCKET ================= */
  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "aaa_virtual"
  });

  const payload = data?.data?.data;
  const { isSuspended, suspendedText } = useClosedPhaseOverlay(
    payload?.evt_status,
    payload?.cat_mid,
    setShowBetSlipPopup
  );
  const payloadResult = data?.data?.result;
  //console.log("data:", payload); // DO NOT REMOVE
  /* ================= TIMER + VALUES ================= */

  const sessionUser = useSelector((s) => s.userStore.data);
  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payload) return;

    updateUserData(data?.user);

    setDisplayLoader(false);

    if (lastStatus !== payload.evt_status && payload.evt_status === "OPEN") {
      setPlacedBets([]);
      setAmarBook(0);
      setAkbarBook(0);
      setAnthonyBook(0);
      setOddBook(0);
      setEvenBook(0);
      setBlackBook(0);
      setRedBook(0);
      setUnder7Book(0);
      setOver7Book(0);

      setAmarWin(false);
      setAkbarWin(false);
      setAnthonyWin(false);
      setOddWin(false);
      setEvenWin(false);
      setBlackWin(false);
      setRedWin(false);
      setUnder7Win(false);
      setOver7Win(false);
    }

    if (lastStatus !== payload.evt_status) {
      setLastStatus(payload.evt_status);
    }
    setRoundId(payload?.cat_mid);
    setB1Val(payload?.b1);
    setB2Val(payload?.b2);
    setB3Val(payload?.b3);
    setB4Val(payload?.b4);
    setB5Val(payload?.b5);
    setB6Val(payload?.b6);
    setB7Val(payload?.b7);
    setB8Val(payload?.b8);
    setB9Val(payload?.b9);
    setB10Val(payload?.b10);
    setPairAVal(payload?.pairA);
    setPairBVal(payload?.pairB);
    if (payload?.result !== "") {
      if (payload?.result == 1) {
        setAmarWin(true);
        setAkbarWin(false);
        setAnthonyWin(false);
      } else if (payload?.result == 2) {
        setAmarWin(false);
        setAkbarWin(true);
        setAnthonyWin(false);
      } else {
        setAmarWin(false);
        setAkbarWin(false);
        setAnthonyWin(true);
      }

      let card = payload?.c1;
      if (card !== "") {
        const lastTwoChars = card.slice(-2);
        if (lastTwoChars == "CC" || lastTwoChars == "HH") {
          setBlackWin(true);
          setRedWin(false);
        } else {
          setBlackWin(false);
          setRedWin(true);
        }

        const firstTwoChars = card.slice(0, -2);
        let numberVal = firstTwoChars;
        if (firstTwoChars == "J") {
          numberVal = 11;
        } else if (firstTwoChars == "Q") {
          numberVal = 12;
        } else if (firstTwoChars == "K") {
          numberVal = 13;
        }

        if (numberVal == 7) {
          setUnder7Win(false);
          setOver7Win(false);
        } else if (numberVal > 7) {
          setUnder7Win(false);
          setOver7Win(true);
        } else {
          setUnder7Win(true);
          setOver7Win(false);
        }

        if (numberVal % 2 === 0) {
          setEvenWin(true);
          setOddWin(false);
        } else {
          setEvenWin(false);
          setOddWin(true);
        }
      }
    }

    const serverSeconds = payload?.left_time;
    if (typeof serverSeconds === "number") {
      setTimeLeft(serverSeconds);
    }

    clearInterval(localTimerRef.current);
    localTimerRef.current = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);

  useEffect(() => () => clearInterval(localTimerRef.current), []);

  /* ================= SINGLE CARD UPDATE + FLIP ================= */
  useEffect(() => {
    if (!payload?.evt_status) return;

    if (lastEvtStatusRef.current === payload.evt_status) return;
    lastEvtStatusRef.current = payload.evt_status;

    if (payload?.c1) {
      setShownCard(payload.c1);
    }

    if (payload.evt_status === "CLOSED") {
      setShouldFlip(true);
    } else {
      setShouldFlip(false);
    }
  }, [payload?.evt_status]);

  /* ================= SVG TIMER ================= */
  const R = 45;
  const CIRC = 2 * Math.PI * R;
  const dash = Math.max(0.0001, CIRC * (timeLeft / TOTAL_SECONDS));
  const timerColor =
    timeLeft <= 5 ? "red" : timeLeft <= 10 ? "orange" : "green";

  /* ================= BET SLIP ================= */
  const showBetfairBetSlip = (
    bettype,
    teamname,
    selectRnr,
    price,
    marketTypeVal,
    sid
  ) => {
    let obj = {
      amount: 0,
      catmid: payload?.cat_mid,
      round: payload?.cat_mid,
      odds: price,
      teamname,
      bettype,
      selectRnr,
      marketVal: 1,
      game_type: 7,
      game_name: "aaa_virtual",
      market_type: marketTypeVal,
      sid: sid
    };

    setPlaceBetObject(obj);
    if (isMobile) {
      setShowBetSlipPopup(true);
    } else {
      setShowBetSlip(true);
    }
  };

  const closeBetSlip = () => setShowBetSlip(false);

  const [profileData, setProfileData] = useState(null);
  const [placedBets, setPlacedBets] = useState([]);
  const [initialBetsFetched, setInitialBetsFetched] = useState(false);

  const fetchProfile = async () => {
    const { data } = await axiosInstance.get("/profile");
    setProfileData(data);
  };

  const betStakeLimit = async () => {
    try {
      const { data } = await axiosInstance.get("/profile/bet-stake-limit");
      if (data != null && data !== undefined) {
        let limit = data?.myBetLimit?.teenpatiStudio;
        setStakeLimit(formatTruncate(limit));
      }
    } catch (error) {
      console.log("Failed to load profile data:", error);
    }
  };

  /// place bet ///
  const closeBetSlipMobile = () => {
    setShowBetSlipPopup(false);
    setBetErrorMessage({});
  };

  async function getPlacedBets() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: payload.cat_mid,
      gametype: "aaa_virtual"
    });
    setPlacedBets(res.data);
  }

  async function getBook() {
    if (!payload?.cat_mid) return;
    const res = await axiosInstance.post("/casino/get-book", {
      cat_mid: payload.cat_mid,
      gametype: "aaa_virtual"
    });
    let books = res?.data;
    if (books !== null && books.length > 0) {
      for (let i = 0; i < books.length; i++) {
        let obj = books[i];
        if (obj.Type == "main") {
          setAmarBook(obj.Amar);
          setAkbarBook(obj.Akbar);
          setAnthonyBook(obj.Anthony);
        }
        if (obj.Type == "fancy") {
          if (obj.rnr_nam == "odd") {
            setOddBook(obj.lay);
          }
          if (obj.rnr_nam == "even") {
            setEvenBook(obj.lay);
          }
          if (obj.rnr_nam == "black") {
            setBlackBook(obj.lay);
          }
          if (obj.rnr_nam == "red") {
            setRedBook(obj.lay);
          }
          if (obj.rnr_nam == "under7") {
            setUnder7Book(obj.lay);
          }
          if (obj.rnr_nam == "over7") {
            setOver7Book(obj.lay);
          }
        }
      }
    }
  }

  useEffect(() => {
    fetchProfile();
    betStakeLimit();
  }, []);

  useEffect(() => {
    if (!initialBetsFetched && payload?.cat_mid) {
      getPlacedBets();
      setInitialBetsFetched(true);
      getBook();
    }
  }, [payload]);

  const placeBet = async (amount, profit) => {
    placeBetObject.amount = amount;
    placeBetObject.profit = profit;
    // placeBetObject.sid1 = payload?.sid1;
    // placeBetObject.sid2 = payload?.sid2;
    // placeBetObject.sid3 = payload?.sid3;

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino",
        placeBetObject
      );

      if (
        response.data !== undefined &&
        response.data !== null &&
        response.data.status !== undefined &&
        response.data.status !== null
      ) {
        let messageObj = {};
        if (response.data.status) {
          messageObj.status = true;
          getPlacedBets();
          setShowBetSlipPopup(false);
          getBook();
        } else {
          messageObj.status = false;
        }
        messageObj.message = response.data.message;
        setBetErrorMessage(messageObj);
      }
    } catch (error) {
      if (error.response.data !== undefined && error.response.data !== null) {
        if (
          error.response.data.status !== undefined &&
          error.response.data.status !== null &&
          error.response.data.status === false
        ) {
          let errorMessage = error.response.data.message;
          let messageObj = {};
          messageObj.status = false;
          messageObj.message = errorMessage;
          setBetErrorMessage(messageObj);
        }
      }
    }
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      showResultDetail();
    }
  };

  const displayRunnerName = (runnerName) => {
    return runnerName
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const displayResult = (index) => {
    let txt = "";
    if (index == 1) {
      txt = "A";
    } else if (index == 2) {
      txt = "B";
    } else {
      txt = "C";
    }
    return txt;
  };

  /// result detail ///
  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "aaa_virtual";

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    setResultData(response.data.results_list);
    //console.log("response->", resultData);
  };
  /// result detail ///

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  //console.log("resultList:", resultList);

  return (
    <div className="aaa-virtual-scope aviator-scope player-scope aviator-bg-black">
      <ClientLayoutWithOutHeader showLoader={false}>
        <div class="details-tabs-wrapper1">
          <div className="main-page">
            <div className="row no-gutters">
              <div className="col-md-12">
                <div className="bodyheight">
                  <div className="wrapper">
                    <TPStudioSidebar open={open} />
                  </div>

                  <div className="lobby-ctn BPGmaindiv">
                    <TpStudioHeader setOpen={setOpen} open={open} />
                    <TpStudioLoader displayLoader={displayLoader} />
                  </div>

                  <div
                    className="row"
                    style={{ display: displayLoader ? "none" : "" }}
                  >
                    <div className="col-md-8">
                      <div className="left-content">
                        <div>
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>AMMAR AKBAR ANTHONY</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                                <AaaRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cards-layout blackjack"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div>
                            <div className="cards-layout blackjack">
                              <div className="col-12 timerDiv2 mb-negative-24">
                                <div
                                  className="row mt-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  <div className="col-2 col-md-1">
                                    <div className="Connectedclients mt-1">
                                      <i
                                        aria-hidden="true"
                                        className="fa fa-user mr-1"
                                        style={{
                                          fontSize: "14px",
                                          color: "white"
                                        }}
                                      />
                                      <b>
                                        <span
                                          id="UsersCount"
                                          className="number"
                                        >
                                          326
                                        </span>
                                      </b>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="col-md-8"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                />

                                <div
                                  className="col-md-2"
                                  style={{
                                    display: activeTabIndex == 1 ? "" : "none"
                                  }}
                                >
                                  {/* Timer with animated stroke + numeric countdown */}
                                  <div className="teenpatti-base-timer">
                                    <svg
                                      viewBox="0 0 100 100"
                                      className="base-timer__svg"
                                    >
                                      <g className="base-timer__circle">
                                        <circle
                                          cx="50"
                                          cy="50"
                                          r="45"
                                          className="base-timer__path-elapsed"
                                        />
                                        <path
                                          strokeDasharray={`${Math.round(
                                            dash
                                          )} ${Math.round(CIRC)}`}
                                          className={`base-timer__path-remaining ${timerColor}`}
                                          d="
                                            M 50, 50
                                            m -45, 0
                                            a 45,45 0 1,0 90,0
                                            a 45,45 0 1,0 -90,0
                                          "
                                        />
                                      </g>
                                    </svg>
                                    <span className="base-timer__label">
                                      {timeLeft == 1 ? 0 : timeLeft}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="table-player mt-0"
                                style={{
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                              >
                                <span className="name player-dt">Winner</span>
                                <div className="player player-card">
                                  <div className="tp-hand-single">
                                    <div
                                      className={`tp-card ${
                                        shouldFlip ? "flip" : ""
                                      }`}
                                    >
                                      <img
                                        src={`/assets/images/cards/${shownCard}.svg`}
                                        draggable={false}
                                        style={{
                                          width: isMobile ? "46px" : "70px",
                                          height: isMobile ? "55px" : "85px"
                                        }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  textAlign: "right",
                                  marginRight: "20px",
                                  display: activeTabIndex == 1 ? "" : "none"
                                }}
                                className="volume-wrapper"
                              >
                                <Volume />
                              </div>
                              {/* Controls removed (auto mode) */}
                            </div>
                          </div>
                        </div>

                        {/* Footer */}
                        <center
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                            <div className="buttons-div">
                              {Object.keys(resultList).map((idx) => (
                                <button
                                  key={idx}
                                  className="video-button border-gradient-btn border-gradient-purple-btn"
                                >
                                  {resultList[idx]}
                                </button>
                              ))}
                            </div>
                            <div className="round-div">
                              <div className="label">Round ID:</div>
                              <div className="id">{roundId}</div>
                            </div>
                          </div>
                        </center>

                        {/* Market Sections (unchanged) */}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div
                            className="tb-content"
                            style={{ background: "#fff" }}
                          >
                            <div className="market-titlebar">
                              <p className="market-name">
                                <span className="market-name-badge">
                                  <i className="market-name-icon">
                                    <img
                                      src="/assets/images/time-img.png"
                                      style={{
                                        filter: "invert(100%)",
                                        marginTop: "-8px",
                                        marginLeft: "-1px"
                                      }}
                                    />
                                  </i>
                                  <span>MATCH ODDS </span>
                                </span>
                              </p>
                              <div className="market-overarround">
                                <span />
                                <strong>Back</strong>
                              </div>
                              <div className="market-overarround market-overarround-lay">
                                <strong>Lay</strong>
                              </div>
                            </div>
                            <div className="market-runners">
                              <div className="runner-runner">
                                <h3
                                  className={
                                    amarWin
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Amar
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  display:
                                                    amarBook != 0 ? "" : "none",
                                                  float: "left",
                                                  color:
                                                    amarBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(amarBook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b1span"
                                    data-teamname="Amar"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "amar",
                                        "amar",
                                        b1Val,
                                        "m",
                                        1
                                      )
                                    }
                                  >
                                    {b1Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3
                                  className={
                                    akbarWin
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Akbar
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  display:
                                                    akbarBook != 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    akbarBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {/*{akbarBook}*/}
                                                {formatTruncate(akbarBook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Akbar"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "akbar",
                                        "akbar",
                                        b2Val,
                                        "m",
                                        2
                                      )
                                    }
                                  >
                                    {b2Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                              <div className="runner-runner">
                                <h3
                                  className={
                                    anthonyWin
                                      ? "runner-name sussesBg"
                                      : "runner-name"
                                  }
                                >
                                  <div className="runner-info">
                                    <span className="clippable runner-display-name">
                                      <table>
                                        <tbody>
                                          <tr>
                                            <td>
                                              <h4
                                                style={{
                                                  marginBottom: 0,
                                                  fontSize: 16,
                                                  fontWeight: "bold"
                                                }}
                                                className="clippable-spacer"
                                              >
                                                Anthony
                                              </h4>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>
                                              <div
                                                style={{
                                                  display:
                                                    anthonyBook != 0
                                                      ? ""
                                                      : "none",
                                                  float: "left",
                                                  color:
                                                    anthonyBook > 0
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: 600
                                                }}
                                              >
                                                {formatTruncate(anthonyBook)}
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </span>
                                  </div>
                                </h3>
                                <div className="price-row-box-new">
                                  {isSuspended && (
                                    <div
                                      className="runner-disabled2"
                                      id="suspendCls1"
                                    >
                                      {suspendedText}
                                    </div>
                                  )}
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-back whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a
                                    className="price-price price-back mb-show span1details"
                                    id="runner1b2span"
                                    data-teamname="Anthony"
                                    data-bettype="b"
                                    onClick={() =>
                                      showBetfairBetSlip(
                                        "b",
                                        "anthony",
                                        "anthony",
                                        b3Val,
                                        "m",
                                        3
                                      )
                                    }
                                  >
                                    {b3Val}
                                    <span className="price-amount" id="rate1">
                                      {stakeLimit}
                                    </span>
                                  </a>
                                  <a className="price-price price-lay ml-4 mb-show">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                  <a className="price-price price-lay mr-4 whtBack">
                                    <div>&nbsp;</div>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ height: "5px" }}
                          className="gap-mob"
                        ></div>
                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>ODD-EVEN </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  oddWin
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Odd
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  oddBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  oddBook > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(oddBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Player A"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "odd",
                                      "odd",
                                      b5Val,
                                      "f",
                                      5
                                    )
                                  }
                                >
                                  {b5Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  evenWin
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Even
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  evenBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  evenBook > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(evenBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Even"
                                  data-bettype="even"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "even",
                                      "even",
                                      b4Val,
                                      "f",
                                      4
                                    )
                                  }
                                >
                                  {b4Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ height: "5px" }}
                          className="gap-mob"
                        ></div>
                        {/*- plus -*/}
                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>COLOR</span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  blackWin
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              BLACK
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  blackBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  blackBook > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(blackBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Player A"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "black",
                                      "black",
                                      b6Val,
                                      "f",
                                      7
                                    )
                                  }
                                >
                                  {b6Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  redWin
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              RED
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  redBook != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  redBook > 0 ? "green" : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(redBook)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Even"
                                  data-bettype="even"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "red",
                                      "red",
                                      b7Val,
                                      "f",
                                      6
                                    )
                                  }
                                >
                                  {b7Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ height: "5px" }}
                          className="gap-mob"
                        ></div>
                        {/*- plus -*/}
                        {/*- plus -*/}
                        <div
                          className="bg-white"
                          style={{
                            display: activeTabIndex == 1 ? "" : "none"
                          }}
                        >
                          <div className="market-titlebar">
                            <p className="market-name">
                              <span className="market-name-badge">
                                <i className="market-name-icon">
                                  <img
                                    src="/assets/images/time-img.png"
                                    style={{
                                      filter: "invert(100%)",
                                      marginTop: "-8px",
                                      marginLeft: "-1px"
                                    }}
                                  />
                                </i>
                                <span>OVER UNDER 7 </span>
                              </span>
                            </p>
                            <div className="market-overarround">
                              <span />
                              <strong>Back</strong>
                            </div>
                            <div className="market-overarround market-overarround-lay">
                              <strong>Lay</strong>
                            </div>
                          </div>
                          <div className="market-runners">
                            <div className="runner-runner">
                              <h3
                                className={
                                  under7Win
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Under 7
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  under7Book != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  under7Book > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(under7Book)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Player A"
                                  data-bettype="b"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "under7",
                                      "under7",
                                      b9Val,
                                      "f",
                                      21
                                    )
                                  }
                                >
                                  {b9Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                            <div className="runner-runner">
                              <h3
                                className={
                                  over7Win
                                    ? "runner-name sussesBg"
                                    : "runner-name"
                                }
                              >
                                <div className="runner-info">
                                  <span className="clippable runner-display-name">
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <h4
                                              style={{
                                                marginBottom: 0,
                                                fontSize: 16,
                                                fontWeight: "bold"
                                              }}
                                              className="clippable-spacer"
                                            >
                                              Over 7
                                            </h4>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <div
                                              style={{
                                                display:
                                                  over7Book != 0 ? "" : "none",
                                                float: "left",
                                                color:
                                                  over7Book > 0
                                                    ? "green"
                                                    : "red",
                                                fontWeight: 600
                                              }}
                                            >
                                              {formatTruncate(over7Book)}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </span>
                                </div>
                              </h3>
                              <div className="price-row-box-new">
                                {isSuspended && (
                                  <div
                                    className="runner-disabled2"
                                    id="suspendCls1"
                                  >
                                    {suspendedText}
                                  </div>
                                )}
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-back whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a
                                  className="price-price price-back mb-show span1details"
                                  id="runner1b1span"
                                  data-teamname="Over 7"
                                  data-bettype="over7"
                                  onClick={() =>
                                    showBetfairBetSlip(
                                      "b",
                                      "over7",
                                      "over7",
                                      b10Val,
                                      "f",
                                      22
                                    )
                                  }
                                >
                                  {b10Val}
                                  <span className="price-amount" id="rate1">
                                    {stakeLimit}
                                  </span>
                                </a>
                                <a className="price-price price-lay ml-4 mb-show">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay whtBack">
                                  <div>&nbsp;</div>
                                </a>
                                <a className="price-price price-lay mr-4 whtBack">
                                  <div>&nbsp;</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*- plus -*/}
                      </div>

                      <div
                        style={{
                          display: activeTabIndex == 2 ? "" : "none",
                          color: "white"
                        }}
                      >
                        <AAAResult resultData={resultData} />
                      </div>
                    </div>

                    <div className="col-md-4">
                      {showBetSlipPopup && (
                        <TPPopUpBetSlip
                          closeBetSlipParent={closeBetSlipMobile}
                          betObj={placeBetObject}
                          placeBetParent={placeBet}
                          betButtonShow={betButtonShow}
                          betErrorMessageObj={betErrorMessageObj}
                          betButtonShowLoaderShow={betButtonShowLoaderShow}
                          profileData={profileData}
                        />
                      )}
                      <TeenPattisCasinoBetslipWeb
                        showBetSlip={showBetSlip}
                        placeBetObject={placeBetObject}
                        closeBetSlipParent={closeBetSlip}
                        placeBetParent={placeBet}
                        betErrorMessageObj={betErrorMessageObj}
                        profileData={profileData}
                      ></TeenPattisCasinoBetslipWeb>
                      <div>
                        <div className="bets">
                          <strong>
                            Matched Bets (0)
                            <img
                              src={reconnecting}
                              alt="dc"
                              className="rounded disconnected"
                              style={{ display: "none" }}
                            />{" "}
                          </strong>
                          <div className="betting-table">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Runner</th>
                                  <th>Price</th>
                                  <th>Size</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {placedBets.map((bet, index) => {
                                  console.log("MATCHED BET:", bet);

                                  return (
                                    <tr
                                      key={index}
                                      style={{
                                        background:
                                          bet.type == "b"
                                            ? "#e9f6fc"
                                            : "#fce3e4"
                                      }}
                                    >
                                      <td>
                                        {displayRunnerName(bet.rnr)} - (
                                        {bet.cat_mid})
                                      </td>

                                      <td>{bet.amnt}</td>
                                      <td>{bet.rate}</td>
                                      <td></td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ClientLayoutWithOutHeader>
      <style>
        {`
            .aaa-virtual-scope .home-content {
              margin-top: 0 !important;
            }

            .aaa-virtual-scope .cards-layout.blackjack {
              position: relative;
              background: #000000;
              min-height: 200px;
            }

            .aaa-virtual-scope .cards-layout.blackjack::before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: radial-gradient(
                ellipse 100% 44% at 50% calc(30% + 40px),
                rgba(62, 193, 65, 0.95) 0%,
                rgba(62, 193, 65, 0.8) 15%,
                rgba(30, 80, 35, 0.5) 40%,
                #1e1e1e 55%,
                #1e1e1e 100%
              );
              opacity: 0.4;
              pointer-events: none;
              z-index: 0;
            }

            .aaa-virtual-scope .cards-layout.blackjack > * {
              position: relative;
              z-index: 1;
            }

            .aaa-virtual-scope .volume-wrapper {
              position: relative;
              top: 8px;
              z-index: 1001;
            }

            .aaa-virtual-scope .volume-wrapper .sound-icon {
              position: relative;
              top: auto;
              right: auto;
              left: auto;
              transform: scale(0.9);
              transform-origin: center;
            }

            .aaa-virtual-scope .teenpatti-base-timer {
              position: relative;
              left: 10px;
            }

            @media (max-width: 768px) {
              .aaa-virtual-scope ul.top-nav,
              .aaa-virtual-scope .top-nav {
                padding-left: 0 !important;
              }

              .aaa-virtual-scope .volume-wrapper {
                top: 0;
              }
            }
          
            .player-scope .table-player .player {
              width: 210px !important;
            }
            .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width: 768px) {
              .left-content center,
              .left-content .bg-white {
                margin-left: 10px;
              }
            }
            @media (min-width:992px){
              .aaa-virtual-scope .cards-layout.blackjack {
                min-height: 200px;
              }
              .volume-wrapper {
                margin-top: -30px;
              }
            }  
            /* mobile */  
            @media (max-width:576px){
            .gap-mob{
              height: 1px !important;
            }
            .footer-divbpg{
                  margin-left: 10px !important;
                  margin-right: 10px !important;
                }
              .cards-layout.blackjack {
                min-height: 120px !important;
              }
              .player-scope .table-player .player {
                width: 170px !important;
                height: 70px !important;
              }
              .titlebarname p{
                font-size: 14px;
              }
              .cards-layout.blackjack .col-12{
                padding-left:0;
                padding-right:0;
              }
              .tp-card img{
                height: 55px;   
                width: auto;
                border-radius: 3px;
              }
              .volume-wrapper {  
                height: 10px !important;
                margin-top: -7px !important;
                line-height: 16px;
                margin-bottom: 10px;
              }
            }  
            
            .player-card {
                height: 100px !important;
            }   
            .tp-card {
              top: 24px !important;  
            }  
          `}
      </style>
    </div>
  );
}
